import React from "react";
import { CONTACT } from "../mock";

const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_freight-match-38/artifacts/az4ptuuw_96CED844-7E24-4E1C-B4DF-11171CEF42D2.png";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container footer-brand">
        <img src={LOGO_URL} alt="Flying Fleet Dispatch LLC — Your success is our mission" className="footer-logo" />
      </div>
      <div className="container foot-row">
        <span>&copy; {year} Flying Fleet Dispatch LLC. All rights reserved.</span>
        <span>
          <a href={`tel:${CONTACT.phoneRaw}`}>{CONTACT.phone}</a> &nbsp;&middot;&nbsp;{" "}
          <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
